<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="Pessoas" :items='questions' :key-form='keyForm'
        prev="/intro/formulario" next="/processos" />
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import Questions from './Questions';

/* eslint-disable max-len */
export default {
  name: 'peoples-form',
  components: { Icon, Questions },
  data() {
    return {
      keyForm: 'people',
      questions: [
        { field: 'td_maturity', value: 0, title: 'A cultura da minha empresa é ser digital. Quando concebemos uma ideia, um projeto ou uma estratégia, desde o início já temos em mente como isso será construído no meio digital.' },
        { field: 'td_leadership_buy_in', value: 0, title: 'Os líderes da minha empresa entendem a magnitude do digital e impulsionam cultura e mudanças nesta direção.' },
        { field: 'td_value', value: 0, title: 'A empresa tem plena consciência da mudança que o digital trará nas competências necessárias para seus colaboradores.' },
        { field: 'td_employee_readiness', value: 0, title: 'Os colaboradores da empresa possuem as habilidades necessárias para se adaptar às mudanças que o digital está trazendo.' },
        { field: 'td_employee_profile', value: 0, title: 'Acredito que a empresa possui as pessoas certas para conduzir processos relacionados à transformação digital.' },
        { field: 'td_communication', value: 0, title: 'A comunicação e transmissão de informação entre os colaboradores de diferentes departamentos é realizada de forma eficiente no ambiente digital.' },
        { field: 'td_openness', value: 0, title: 'A empresa se demonstra aberta para inovações por parte dos funcionários relacionadas ao ambiente digital.' },
        { field: 'td_inovation', value: 0, title: 'A empresa viabiliza e põe em prática inovações sugeridas por funcionários relacionadas ao ambiente digital.' },
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PeoplesForm.vue